import { Link } from "react-router-dom";
import useSeo from "../lib/useSeo";

export default function NotFound() {
  useSeo({ title: "Page introuvable | Mon Serrurier Breton", description: "Cette page n'existe pas.", path: "/404", robots: "noindex, follow" });
  return (
    <section data-testid="page-not-found" className="max-w-3xl mx-auto px-4 py-24 text-center space-y-6">
      <h1 className="font-display text-4xl sm:text-5xl font-extrabold text-slate-900">Page introuvable</h1>
      <p className="text-slate-600">Cette page n'existe pas ou a été déplacée.</p>
      <Link to="/" data-testid="not-found-home-link" className="inline-flex bg-teal-600 hover:bg-teal-700 text-white font-bold rounded-full px-6 py-3 transition-colors">
        Retour à l'accueil
      </Link>
    </section>
  );
}
